<template>
<div class="chapter">
<div class="inner_page">
<div class="didbox">
<p class="h1fm" id="ack">Acknowledgments</p>
<p class="did">Thank you to my mother, Penelope, my first embroidery teacher.</p>
<p class="did">And to the crew at C&amp;T Publishing, who always make me look good.</p>
</div>
<p class="image"><img alt="" src="images/pg2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?acf96a7c